import { ChevronRight } from "@mui/icons-material";
import { Breadcrumb } from "antd";

export const BreadcrumbComponent = ({ items = [] }) => {
  return (
    <Breadcrumb
      separator={<ChevronRight />}
      items={[
        {
          title: "Home",
          href: "/",
        },
        ...items,
      ]}
    />
  );
};
